export const IDLE_TIMEOUT_MS = 20 * 60 * 1000;
